// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { LinkRelationType } from "./LinkRelationType";
import {
  LinkRelationTypeFromJSON,
  LinkRelationTypeFromJSONTyped,
  LinkRelationTypeToJSON,
  LinkRelationTypeToJSONTyped,
} from "./LinkRelationType";

/**
 *
 * @export
 * @interface Rel
 */
export interface Rel {}

/**
 * Check if a given object implements the Rel interface.
 */
export function instanceOfRel(value: object): value is Rel {
  return true;
}

export function RelFromJSON(json: any): Rel {
  return RelFromJSONTyped(json, false);
}

export function RelFromJSONTyped(json: any, ignoreDiscriminator: boolean): Rel {
  return json;
}

export function RelToJSON(json: any): Rel {
  return RelToJSONTyped(json, false);
}

export function RelToJSONTyped(value?: Rel | null, ignoreDiscriminator: boolean = false): any {
  return value;
}
